import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Clock, User } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Articles = () => {
  const navigate = useNavigate();
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState('all');
  
  useEffect(() => {
    fetchArticles();
  }, []);
  
  const fetchArticles = async () => {
    try {
      const response = await axios.get(`${API}/articles`);
      setArticles(response.data);
    } catch (error) {
      console.error('Error fetching articles:', error);
    } finally {
      setLoading(false);
    }
  };
  
  const categories = [
    { value: 'all', label: 'כל המאמרים' },
    { value: 'שיפור האון הגברי', label: 'שיפור האון הגברי' },
    { value: 'תזונה נכונה', label: 'תזונה נכונה' },
    { value: 'אימונים ותרגילים', label: 'אימונים ותרגילים' }
  ];
  
  const filteredArticles = selectedCategory === 'all'
    ? articles
    : articles.filter(article => article.category === selectedCategory);
  
  if (loading) {
    return (
      <div className="container py-16" data-testid="articles-loading">
        <div className="text-center">
          <p className="text-xl text-stone-600">טוען מאמרים...</p>
        </div>
      </div>
    );
  }
  
  return (
    <div className="container py-16" data-testid="articles-page">
      <div className="text-center mb-12">
        <h1 className="text-4xl md:text-5xl font-bold text-[#2C3E2D] mb-4" style={{ fontFamily: 'Heebo, sans-serif' }} data-testid="articles-title">
          מאמרים בנושא
        </h1>
        <p className="text-base md:text-lg text-stone-600">
          מידע מקצועי ועדכני לבריאות הגבר
        </p>
      </div>
      
      {/* Category Filter */}
      <div className="flex flex-wrap justify-center gap-4 mb-12" data-testid="category-filter">
        {categories.map((category) => (
          <button
            key={category.value}
            data-testid={`category-${category.value}`}
            onClick={() => setSelectedCategory(category.value)}
            className={`px-6 py-3 rounded-full font-medium transition-all duration-300 ${
              selectedCategory === category.value
                ? 'bg-[#D97706] text-white shadow-md'
                : 'bg-white text-stone-600 hover:bg-stone-100 border border-stone-200'
            }`}
            style={{ fontFamily: 'Heebo, sans-serif' }}
          >
            {category.label}
          </button>
        ))}
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="articles-grid">
        {filteredArticles.map((article) => (
          <article
            key={article.id}
            data-testid={`article-${article.id}`}
            onClick={() => navigate(`/articles/${article.id}`)}
            className="bg-white rounded-2xl overflow-hidden border border-stone-100 hover:shadow-lg transition-all duration-300 group cursor-pointer"
          >
            <div className="aspect-video overflow-hidden">
              <img
                src={article.image}
                alt={article.title}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
              />
            </div>
            
            <div className="p-6">
              <div className="mb-3">
                <span className="text-xs font-semibold text-[#D97706] bg-[#D97706]/10 px-3 py-1 rounded-full">
                  {article.category}
                </span>
              </div>
              
              <h2 className="text-xl font-semibold text-[#2C3E2D] mb-3 leading-tight" style={{ fontFamily: 'Heebo, sans-serif' }}>
                {article.title}
              </h2>
              
              <p className="text-stone-600 text-sm mb-4 leading-relaxed">
                {article.excerpt}
              </p>
              
              <div className="flex items-center gap-4 text-sm text-stone-500">
                <div className="flex items-center gap-1">
                  <User className="w-4 h-4" />
                  <span>{article.author}</span>
                </div>
                <div className="flex items-center gap-1">
                  <Clock className="w-4 h-4" />
                  <span>{article.read_time} דקות</span>
                </div>
              </div>
            </div>
          </article>
        ))}
      </div>
      
      {filteredArticles.length === 0 && (
        <div className="text-center py-16" data-testid="no-articles">
          <p className="text-xl text-stone-600">אין מאמרים זמינים בקטגוריה זו</p>
        </div>
      )}
    </div>
  );
};

export default Articles;